
// Get visible selections

  export default (learningobjective_userselects, { userId }) => {
    return learningobjective_userselects;
  };